<template>
  <page-outline :title="$t('Webheader.sepa_core_collection')">
    <template slot="pageContent">
      <b-row class="min-w-100 justify-content-start align-items-center">
        <b-col cols="12" class="d-flex justify-content-start mt-3 mb-5">
          <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl" :menuLink="'/mandatpage/unit'"></back-button>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="12" class="mt-3">
          <div>
            <form-accordion :title="$t('mandate.mandate_info')" :isTitleUpperCase="false">
              <div style="padding-top: 1.5rem; padding-bottom: 1.5rem;">
              <b-row class="ml-0 mr-5 form-group">
                <b-col sm="5">
                  <form-read-group-label-input
                    :inputLabel="$t('mandate.unique_mandate_rf')" :inputValue="UMR">
                  </form-read-group-label-input>
                </b-col>
              </b-row>
              </div>
            </form-accordion>
            <form-accordion :title="$t('mandate.cdtr_info')" :isTitleUpperCase="false">
              <div style="padding-top: 1.5rem; padding-bottom: 1.5rem;">
              <b-row class="ml-0 mr-5 form-group">
                <b-col sm="5">
                  <iban-input
                    v-model="IbanSelected"
                    :label="$t('mandate.cdtr_iban')"
                    :required="true"
                    :hint="$t('mandate.iban_hint') || ''"
                  />
                </b-col>
              </b-row>
              </div>
            </form-accordion>
            <form-accordion :title="$t('mandate.details_transactions')" :isTitleUpperCase="false">
              <b-row class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
              <!--
                <b-col sm="5">
                  <label>
                    {{ $t('mandate.collection_type') }} <span style="color: red">*</span>
                  </label>
                  <select class="form-control" v-model="CollectionTypeSelected">
                    <option value="" disabled selected>{{ $t('mandate.collection_type_select') }}</option>
                    <option v-for="type in CollectionType" :key="type.value" :value="type.value">
                      {{ $t(type.label) }}
                    </option>
                  </select>
                </b-col>
                -->
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="Amount"
                    :inputLabel="$t('mandate.amt') + ' (€)'"
                    :placeholderValue="$t('mandate.amt') + ' (€)'"
                    isMandatory
                    inputType="number">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="5">
                  <div>
                    <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_due') }} <span style="color: red">*</span></span>
                    <datetime-picker-custom
                      :showTime="false"
                      format="YYYY-MM-DD"
                      periodFull
                      id="filter-datebegin"
                      class="mr-3"
                      :class="{'filter-item-input': true, 'filter-item-input-complete': DueDate}"
                      customInputParentClass="filter-item-content"
                      customInputClass="w-100"
                      style="padding:0.35rem"
                      :maxLength="19"
                      :placeholderValue="$t('common.datepicker_format_date3')"
                      inputIcon="fa-solid fa-calendar"
                      disablePastDates
                      v-model="DueDate"/>
                  </div>
                </b-col>
              </b-row>
              <b-row class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="CdtrRefCollection"
                    :inputLabel="$t('mandate.cdtr_ref')"
                    :placeholderValue="$t('mandate.cdtr_ref')">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="Purpose"
                    :inputLabel="$t('mandate.purpose')"
                    :placeholderValue="$t('mandate.purpose')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row class="ml-0 mt-4 mb-4 mr-5 mr-5 form-group">
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="PurposeCategory"
                    :inputLabel="$t('mandate.purpose_category')"
                    :placeholderValue="$t('mandate.purpose_category')">
                  </form-write-group-label-input>
                </b-col>
                <b-col sm="5">
                  <form-write-group-label-input
                    v-model="RemittanceInfo"
                    :inputLabel="$t('mandate.remittance_info')"
                    :placeholderValue="$t('mandate.remittance_info')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
            <b-row class="form-group justify-content-end">
              <b-col sm="2">
                <b-button
                  class="btnFilter_2"
                  variant="primary"
                  @click="sendTransaction"
                  :disabled="!isFormValid">
                  <i class="fa-light fa-paper-plane" size="17px"></i>
                  <span>{{ $t('mandate.send') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import { errorMessageAlert } from "@/helpers/alert"
import moment from 'moment-timezone'
import BackButton from '@/components/common/backButton.vue'
import IbanInput from '@/components/common/IbanInput.vue'
import { normalizeIban, validateIban } from '@/helpers/iban'

export default {
  components: {
    BackButton,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    'iban-input': IbanInput
  },
  data () {
    return {
      Amount: '',
      CdtrRefCollection: '',
      CollectionType: [
        { value: 1, label: 'mandate.collection_type_1' },
        { value: 2, label: 'mandate.collection_type_2' },
        { value: 3, label: 'mandate.collection_type_3' },
        { value: 4, label: 'mandate.collection_type_4' },
        { value: 5, label: 'mandate.collection_type_5' }
      ],
      CollectionTypeSelected: '',
      DueDate: '',
      IbanSelected: '',
      Purpose: '',
      PurposeCategory: '',
      RemittanceInfo: '',
      timezone: '+00:00'
    }
  },
  created() {
    this.IdMandate = this.$route.query.IdMandate
    this.UMR = this.$route.query.UMR
    this.returnUrl = '/mandatedetail/' + this.IdMandate
  },
  computed: {
    isFormValid() {
      const hasIBAN = (this.IbanSelected || '').trim().length > 0
      const hasAmount = (this.Amount || '').trim().length > 0
      const dateStr = (this.DueDate || '').trim()
      const hasDueDate =
        /^\d{4}-\d{2}-\d{2}$/.test(dateStr) &&
        moment(dateStr, 'YYYY-MM-DD', true).isValid()
      return hasIBAN && hasAmount && hasDueDate
    }
  },
  // watch: {
  //   IbanSelected(value) {
  //     if (value) {
  //       this.IbanSelected = value.replace(/\s+/g, '')
  //     }
  //   }
  // },
  methods: {
    convertToISOStringFormat(dateTimeStr) {
      if (!dateTimeStr) return ''
      return dateTimeStr.replace(' ', 'T')
    },
    formHasError () {
      // if (this.IbanSelected === undefined || this.IbanSelected === '') {
      //   this.okMessageBox(this.$t('mandate.missing_iban'))
      //   return true
      // }
      // --- contrôle IBAN via helper ---
      const res = validateIban(this.IbanSelected)

      if (!res.valid) {
        let msg = ''

        if (this.$t) {
          switch (res.code) {
            case 'empty':
              msg = this.$t('mandate.iban_required')
              break
            case 'invalid_chars':
              msg = this.$t('mandate.iban_invalid_chars')
              break
            case 'too_short':
              msg = this.$t('mandate.iban_too_short')
              break
            case 'country_not_supported':
              msg = this.$t('mandate.iban_country_not_supported', {
                country: res.country || ''
              })
              break
            case 'wrong_length':
              msg = this.$t('mandate.iban_wrong_length', {
                country: res.country || ''
              })
              break
            case 'checksum':
              msg = this.$t('mandate.iban_invalid_checksum')
              break
            default:
              msg = this.$t('mandate.iban_invalid_generic') || 'IBAN invalide'
          }
        } else {
          msg = 'IBAN invalide'
        }

        this.okMessageBox(msg)
        return true
      }
      // if (this.DueDate === undefined || this.DueDate === '') {
      //   this.okMessageBox(this.$t('mandate.missing_due_date'))
      //   return true
      // }
      // if (this.Amount === undefined || this.Amount === '') {
      //   this.okMessageBox(this.$t('mandate.missing_amt'))
      //   return true
      // }
      let dueDateMoment = moment(this.DueDate, 'YYYY-MM-DD')
      let tomorrow = moment().add(1, 'days').startOf('day')
      if (dueDateMoment.isBefore(tomorrow)) {
        this.okMessageBox(this.$t('mandate.due_date_must_be_tomorrow_or_later'))
        return true
      }

      return false
    },
    // isValidIban (iban) {
    //   if (!iban) return false
    //
    //   const clean = iban.replace(/\s+/g, '')
    //   return clean.length === 27
    // },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    sendTransaction () {
      let that = this

      if (!this.isFormValid) return

      if (this.formHasError()) {
        return
      }
      const cleanIban = normalizeIban(this.IbanSelected)

      let params = {
        IdMandate: this.IdMandate,
        UMR: this.UMR,
        Amount: this.Amount,
        Purpose: this.Purpose,
        PurposeCategory: this.PurposeCategory,
        RemittanceInfo: this.RemittanceInfo,
        DueDate: this.convertToISOStringFormat(this.DueDate),
        CdtrRefCollection: this.CdtrRefCollection,
        CdtrIBAN: cleanIban
      }
      this.$engine.Collection.addCollection(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('mandate.added_collection'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/mandatetransactions/unit'})
      })
      .catch(e => {
        errorMessageAlert(e, that, that.$i18n)
      })
    }
  }
}
</script>
